// Better Auth client — email/password + social login (Google, X, Microsoft)
import { createAuthClient } from 'better-auth/react';

// On the CRA dev server (:3000) the OAuth redirects must go through Wrangler (:8787),
// mirroring the legacy /auth/google behaviour. Cookies are shared across localhost ports.
const baseURL = (typeof window !== 'undefined' && window.location.port === '3000')
  ? 'http://localhost:8787'
  : (typeof window !== 'undefined' ? window.location.origin : '');

export const authClient = createAuthClient({
  baseURL,
  basePath: '/api/betterauth',
});
